import React, { useState, useEffect } from "react";
import { PublicKey } from "@solana/web3.js";
import { encodeURL } from "@solana/pay";
import styles from "./css/Makepayment.module.css";

export default function MakePayment() {
  useEffect(() => {
    const els = document.querySelectorAll('[data-bs-toggle="popover"]');
    els.forEach((el) => new window.bootstrap.Popover(el));
  }, []);

  const recipient = new PublicKey(
    "4GX1hDmkpCaRDcNHdjMDeXP19FXh56xbZGRpsK5nmdyq"
  ); // Your wallet

  // Generate a unique order ID
  const [orderId] = useState(
    () => "order_" + Math.random().toString(36).substring(2, 9)
  );

  // Build the Solana Pay URL WITHOUT amount
  const paymentUrl = encodeURL({
    recipient,
    label: "PinkPony Girl Coin",
    message: `Order ${orderId}`,
    memo: orderId,
  }).toString();

  const handlePay = () => {
    // Open Phantom (or any wallet) with the URL
    window.open(paymentUrl, "_blank");
  };

  return (
    <div
      style={{
        fontFamily: "sans-serif",
        padding: 20,
        alignContent: "center",
        display: "flex",
      }}
    >
      <button
        onClick={handlePay}
        className="btn btn-warning text-black fw-bold rounded-0 me-2"
      >
        Buy Now
      </button>

      <i
        className={`${styles.informationIcon} fa fa-circle-info fa-2x`}
        data-bs-toggle="popover"
        data-bs-placement="right"
        data-bs-content=" By clicking the buy button you can buy and purchase the PPGC GOLD simultaneously with any Solana wallet that opens on your device"
      ></i>

      {/* <p style={{ marginTop: 10, fontSize: 12, color: "#555" }}>
        Order ID: <code>{orderId}</code>
      </p> */}
    </div>
  );
}
